var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFloorplanIconBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 26h8v-2H0zM11 26h10v-2H11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 26h2V1H0zM20 26h2V13h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2h25V0H0zM20 14h6v-2h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 13h2V0h-2zM13 12h2V1h-2zM13 25h2v-7h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10h6V8H8zM1 10h5V8H1zM0 18h8v-2H0zM6 25h2v-7H6zM13 18h8v-2h-8z"
  }))));
}
export default SvgFloorplanIconBlack;